{
  "familyId": "SWW-VD-HOMOFOON",
  "questions": [
    {
      "id": "SWW-VD-HOMOFOON-001",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Welke werkwoordsvorm past? 'Als ik het ... (weten), had ik het gezegd.'",
      "context": null,
      "options": ["had geweten", "wist", "weet", "geweten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Voltooid Verleden Tijd", "content": "Voltooid verleden tijd: had/was + voltooid deelwoord. Voorbeeld: had geweten, was gegaan.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "all_tenses_mix",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: voltooid verleden tijd (plusquamperfectum). Stap 1: De zin beschrijft iets dat in het verleden had kunnen gebeuren ('Als ik het ..., had ik het gezegd'). Stap 2: Dit vraagt om voltooid verleden tijd: had/was + voltooid deelwoord. Stap 3: Het voltooid deelwoord van 'weten' is 'geweten'. Dus: had geweten. Checkstrategie: staat er 'had' of 'was' in de zin? Dan voltooid deelwoord erbij.",
        "distractorExplanations": {
          "0": "Correct! Voltooid verleden tijd: had + voltooid deelwoord = had geweten.",
          "1": "Veelgemaakte fout: gewone verleden tijd gebruiken in plaats van voltooid verleden tijd. 'Wist' is de gewone verleden tijd. De constructie 'Als ik het ... had ik ...' vraagt om voltooid verleden tijd: had geweten. Misconceptie: de gewone verleden tijd verwarren met de voltooid verleden tijd.",
          "2": "Veelgemaakte fout: tegenwoordige tijd gebruiken in een verleden-tijdcontext. 'Weet' is de tegenwoordige tijd. De zin beschrijft het verleden ('had ik het gezegd'), dus: had geweten.",
          "3": "Veelgemaakte fout: het hulpwerkwoord weglaten. 'Geweten' alleen is onvolledig. De voltooid verleden tijd heeft altijd een hulpwerkwoord nodig: had geweten (niet alleen geweten)."
        }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-002",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een word/wordt-fout:",
      "context": "Ik wordt morgen jarig.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Ik wordt morgen jarig.",
        "correctHighlights": [{"start": 3, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Word vs. Wordt", "content": "Checkstrategie: vervang door 'smurfen'. Klinkt 'smurf' goed? Dan 'word'. Klinkt 'smurft' goed? Dan 'wordt'.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "word_wordt_confusion",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: dt-regel (word vs. wordt). Stap 1: De stam van 'worden' is 'word' (eindigt op d). Stap 2: Bij 'ik' gebruik je alleen de stam: ik word (ZONDER t). Stap 3: 'Ik wordt' is fout — de -t hoort er niet bij 'ik'. Checkstrategie: vervang door 'smurfen': 'Ik smurf morgen jarig' (niet 'Ik smurft') → dus: ik word.",
        "distractorExplanations": { "1": "Correct! Dt-regel: 'wordt' moet 'word' zijn bij 'ik'. Bij 'ik' gebruik je alleen de stam zonder -t: ik word. Misconceptie: denken dat 'wordt' altijd met -t geschreven wordt." }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-003",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een word/wordt-fout:",
      "context": "Hij word steeds sterker door te sporten.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Hij word steeds sterker door te sporten.",
        "correctHighlights": [{"start": 4, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Word vs. Wordt", "content": "Bij hij/zij/het voeg je -t toe: hij wordt. Checkstrategie: 'Hij smurft' (met t) klinkt goed, dus: hij wordt.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "word_wordt_hij_form",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "'Word' is fout bij 'hij'. Checkstrategie: 'Hij smurft steeds sterker' (met t) klinkt goed. Dus: hij wordt (met t). De stam 'word' + t = wordt (dt).",
        "distractorExplanations": { "1": "Correct! 'Word' moet 'wordt' zijn. Bij hij voeg je -t toe: word + t = wordt (dt)." }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-004",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een word/wordt-fout:",
      "context": "Het word tijd om te gaan.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Het word tijd om te gaan.",
        "correctHighlights": [{"start": 4, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Word vs. Wordt", "content": "Bij het voeg je -t toe: het wordt. Checkstrategie: 'Het smurft' (met t) klinkt goed, dus: het wordt.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "word_wordt_het_form",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "'Word' is fout bij 'het'. Checkstrategie: 'Het smurft tijd' (met t) klinkt goed. Dus: het wordt (met t). De stam 'word' + t = wordt (dt).",
        "distractorExplanations": { "1": "Correct! 'Word' moet 'wordt' zijn. Bij het voeg je -t toe: word + t = wordt (dt)." }
      }
    }
  ]
}
